var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, NavItemContainer, NavSection, Sidebar } from "./styles";
import { Box, Typography } from "@mui/material";
export default function sideMenu(_a) {
    var sections = _a.sections, activeSectionId = _a.activeSectionId, onSectionClick = _a.onSectionClick;
    return (_jsx(Container, { children: _jsxs(Sidebar, { children: [_jsx(NavSection, { children: sections.map(function (section) { return (_jsx(NavItem, { icon: section.icon, label: section.name, active: section.id === activeSectionId, hasChildren: true, onClick: function () { return onSectionClick(section.id); } }, section.id)); }) }), _jsx(Box, {})] }) }));
}
function NavItem(_a) {
    var icon = _a.icon, label = _a.label, active = _a.active, hasChildren = _a.hasChildren, onClick = _a.onClick;
    return (_jsxs(NavItemContainer, __assign({ active: active, onClick: onClick }, { children: [icon, _jsx(Typography, __assign({ sx: { flex: 1 } }, { children: label }))] })));
}
